<template>
  <!-- 底部 -->
  <div class="footer">
    <ul class="bet">
      <li class="left">
        <h2 class="title">加入我们 Join Us</h2>
        <span class="basenw first">我们随时准备为您提供帮助</span>
        <span style="line-height: 15px">We are always ready to help you.</span>
        <p class="p1">江苏省 南京市 秦淮区 紫云大道9号</p>
        <p class="p2">
          9 Ziyun Avenue, Qinhuai District, Nanjing City, Jiangsu Province
        </p>
        <span class="basenw">总机Phone：025-86530977</span>
        <span class="basenw">传真Fax：025-86530677</span>
        <span class="basenw">HR分机Extension：6845</span>
        <a
          href="mailto:sample@163.com?subject=test&cc=sample@hotmail.com&body=use mailto sample"
          ><span>邮箱Email：jswx@js-wx.com.cn</span></a
        >
        <a href="https://beian.miit.gov.cn/" target="blank">
          <span>网站备案号：苏ICP备2021019024号</span>
        </a>
        <span class="basenw">公司名称：江苏纬信工程咨询有限公司</span>
      </li>
      <li class="right">
        <h2 class="title">导航 Navivgation</h2>
        <span @click="to('/companyprofile/introduction')"
          >>&nbsp; &nbsp;&nbsp;公司概况</span
        >
        <span @click="to('/news/index')">>&nbsp; &nbsp;&nbsp;新闻动态</span>
        <span @click="to('/ourservices/project')"
          >>&nbsp; &nbsp;&nbsp;我们的服务</span
        >
        <span @click="to('/joinus/joinusdetail')"
          >>&nbsp; &nbsp;&nbsp;加入我们</span
        >
        <span @click="to('/client')">>&nbsp; &nbsp;&nbsp;客户反馈</span>
        <span @click="to('/connectus/connectus')"
          >>&nbsp; &nbsp;&nbsp;联系我们</span
        >
        <!-- <span @click="to('/branch/branch')">>&nbsp; &nbsp;&nbsp;分支机构</span> -->
        <span
          v-show="false"
          @click="
            toOut(
              'http://178.18.30.32:8088/portal/Portal.aspx?PortalType=Enterprise'
            )
          "
          >>&nbsp; &nbsp;&nbsp;内部系统</span
        >
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "wx-footer",
  data() {
    return {};
  },
  components: {},
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    to(v) {
      if (v) {
        this.$router.push(v);
      }
    },
    toOut(v) {
      var body = document.querySelector("body");
      let a = document.createElement("a");
      a.target = "_blank";
      a.href = v;
      body.appendChild(a);
      a.click();
    },
  },
};
</script>
<style scoped lang='less'>
@bottomColor: #061a32;
@co: #f39518;
@co3: rgba(184, 36, 60);
@time: 1s;
.ani {
  transition: all 0.3s linear;
}
// 底部
.footer {
  background: @bottomColor;
  width: 100%;
  height: 600px;
  position: relative;
  bottom: -100px;
  // padding-top: 36px;
  padding: 60px;
  .bet {
    width: 100%;
    display: flex;
    li {
      flex: 1;
      display: flex;
      flex-flow: column;
      padding-left: 240px;
    }
    .left {
      span {
        color: #999899;
        font-size: 16px;
        line-height: 35px;
      }
      p {
        font-size: 16px;
        color: #ffffff;
      }
      .p1 {
        margin-top: 40px;
        line-height: 35px;
      }
      .p2 {
        margin-bottom: 40px;
      }
    }
    .title {
      color: @co;
      text-align: left;
      line-height: 80px;
    }
    .right {
      // .navbar {
      //   color: white;
      //   font-size: 24px;
      //   line-height: 65px;
      // }
      .title {
        color: @co;
        text-align: left;
        line-height: 80px;
      }
      span {
        color: @co;
        font-size: 16px;
        line-height: 50px;
        width: 200px;
        display: inline-block;
        cursor: pointer;
        .ani();
        &:hover {
          transform: translate(10px, 0);
        }
      }
    }
  }
}
@media screen and (max-width: @mbwidth) {
  .mb() !important;
}
.mb {
  .first {
    line-height: 18px;
  }
  .footer {
    padding: 0px;
  }
  ul {
    justify-content: space-between;
  }
  li {
    width: 140px;
    flex: 0 1 auto;
  }
  .bet {
    width: 80%;
    margin: 0 auto;
  }
  .left {
    padding-left: 0;
    width: 50%;
    width: 145px;
  }
  .right {
    width: 50%;
    padding-left: 0%;
    width: 132px;
    span{
      line-height: 49px;
      position: relative;
      top: -10px;
    }
  }
  p{
    font-size: 12px;
  }
  .p1 {
    margin-top: 10px;
    .first()
  }
  .p2 {
    margin-bottom: 10px;
    line-height: 15px;
  }
  h2 {
    font-size: 16px;
  }
  span {
    font-size: 12px;
  }
  p {
    font-size: 12px;
  }
}
.basenw {
  white-space: nowrap;
}
</style>


// WEBPACK FOOTER //
// src/components/footer/index.vue